import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../../commons/app-commons.module';


import { KYMW1600Model } from '../kymw1600.model';
import { ImageInfoListComponent } from './image-info-list.component';
import { ImageInfoDetailBoxModule } from '../image-info-detail-box/image-info-detail-box.module';
import { ImageInfoRendererModule } from '../image-info-renderer/image-info-renderer.module';

/**
 * 画像情報詳細部品 モジュール設定クラス
 *
 * @export ImageInfoDetailModule
 * @class ImageInfoDetailModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    ImageInfoDetailBoxModule,
    ImageInfoRendererModule,
  ],
  declarations: [
    ImageInfoListComponent,
  ],
  providers: [
    KYMW1600Model,
  ],
  exports: [
    ImageInfoListComponent
  ]
})
export class ImageInfoListModule {
}
